import { useGetUserQuery, useUpdateUserActivationDataMutation } from 'common'

export const useSpotlightState = () => {
  const { data: { activation_data: { spotlights = {} } = {} } } = useGetUserQuery()

  const [update] = useUpdateUserActivationDataMutation()

  return [
    spotlights,
    (data) => update({ spotlights: { ...spotlights, ...data } }),
  ]
}
